import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import ClientStatusPage from "@/pages/ClientStatusPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminRegister from "@/pages/AdminRegister";
import VerifyEmailPage from "@/pages/VerifyEmailPage"; // 👈 NUEVO: Importamos la pantalla
import AdminDashboard from "@/pages/AdminDashboard";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import SubscriptionPage from "@/pages/SubscriptionPage"; 
import ProtectedRoute from "@/components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword"; // (Asegúrate de que la ruta coincida con donde lo guardaste)
import DemoDashboard from "./pages/DemoDashboard";
import ClientPortal from "@/pages/ClientPortal";

function App() {
  return (
    <div className="App min-h-screen bg-[#09090b]">
      <div className="noise-overlay" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/cliente" element={<ClientPortal />} />
            <Route path="/:slug" element={<BookingPage />} />
            <Route path="/reservar" element={<BookingPage />} />
            <Route path="/reservar/:slug" element={<BookingPage />} />
            <Route path="/mi-cita" element={<ClientStatusPage />} />
            <Route path="/mi-cita/:slug" element={<ClientStatusPage />} />
            
            {/* Auth routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/demo" element={<DemoDashboard />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/register" element={<AdminRegister />} />
            <Route path="/admin/verify-email" element={<VerifyEmailPage />} /> {/* 👈 NUEVO: La ruta del código */}
            <Route path="/admin/subscription" element={<SubscriptionPage />} /> 
            
            {/* Protected admin routes */}
            <Route path="/admin" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            {/* Super admin routes */}
            <Route path="/superadmin" element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <SuperAdminDashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#18181b',
            border: '1px solid #f59e0b',
            color: '#fafafa',
          },
        }}
      />
    </div>
  );
}

export default App;